module.exports = __webpack_public_path__ + "img/slushies.82c4b8eb.jpg";